export const styleSheet = theme => ({
    container: {
        backgroundColor: theme.colors.white02
    }
});
